import { createFileRoute } from "@tanstack/react-router";
import ImportDealerApify from "@/pages/admin/ImportDealerApify";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/admin/import-dealer-apify/")({
  head: () => routeHead("/admin/import-dealer-apify/"),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <ImportDealerApify />
  );
}
